import React, { useId } from 'react';
import { ChevronDown } from 'lucide-react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: SelectOption[];
  error?: string;
  helperText?: React.ReactNode;
  placeholder?: string;
  required?: boolean;
}
export function Select({
  label,
  options,
  error,
  helperText,
  placeholder = 'Select an option',
  required,
  className = '',
  id,
  ...props
}: SelectProps) {
  const reactId = useId();
  const selectId = id || props.name || `sel-${reactId}`;
  const helperId = helperText ? `${selectId}-help` : undefined;
  const errorId = error ? `${selectId}-err` : undefined;
  const describedBy = [errorId, helperId].filter(Boolean).join(' ') || undefined;
  return <div className="w-full" data-id="element-1013">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-900 mb-1.5" data-id="element-1014">
          {label}
          {required && <span className="text-red-600 ml-0.5" aria-hidden="true" data-id="element-1015">
              *
            </span>}
          {required && <span className="sr-only" data-id="element-1016"> (required)</span>}
        </label>}
      <div className="relative" data-id="element-1017">
        <select id={selectId} required={required} aria-invalid={error ? true : undefined} aria-describedby={describedBy} className={`
            block w-full min-h-[44px] rounded-lg border-2 shadow-sm appearance-none
            bg-white text-gray-900
            focus:outline-none focus:border-[#B8860B] focus:ring-2 focus:ring-[#B8860B] focus:ring-offset-1
            disabled:bg-gray-100 disabled:text-gray-600 disabled:border-gray-300
            sm:text-sm py-3 pl-3 pr-10
            ${error ? 'border-red-600 focus:border-red-700 focus:ring-red-600' : 'border-gray-500'}
            ${className}
          `} {...props} data-id="element-1018">
          <option value="" disabled data-id="element-1019">
            {placeholder}
          </option>
          {options.map(option => <option key={option.value} value={option.value} data-id="element-1020">
              {option.label}
            </option>)}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-700" aria-hidden="true" data-id="element-1021">
          <ChevronDown className="h-4 w-4" data-id="element-1022" />
        </div>
      </div>
      {helperText && !error && <p id={helperId} className="mt-1 text-xs text-gray-600" data-id="element-1023">
          {helperText}
        </p>}
      {error && <p id={errorId} className="mt-1 text-sm text-red-700 font-medium" role="alert" data-id="element-1024">
          {error}
        </p>}
    </div>;
}